import React from 'react';

export default function Footer() {
  return (
    <div className="app-footer">
      Designed &amp; Developed by{' '}
      <a href="https://www.odinno.com" target="_blank" rel="noopener noreferrer">
        www.odinno.com
      </a>
    </div>
  );
}
